import DeliveryMatrixSummary from "./DeliveryMatrixSummary/DeliveryMatrixSummary";
import DeliveryMatrixDetails from "./DeliveryMatrixDetails/DeliveryMatrixDetails";

export const toListTableRows = (items, tableColumns) => {
  return items?.map(item => ({
    id: item.destinationId,
    shopName: item.destinationName,
    summary: <DeliveryMatrixSummary item={item} />,
    details: <DeliveryMatrixDetails item={item} tableColumns={tableColumns} />,
    borderLeftColor: '#0970E6',
    defaultExpanded: true
  }))
}

export const toDetailsTableRows = (items) => {
  return items?.map((item, index) => ({
    deposit: item.deposit,
    deliveryDeposit: item.deliveryDeposit,
    paxdDeposit: item.paxdDeposit,
    receptionHub: item.receptionHub,
    acceptReturns: item.acceptReturns,
    deliveryMatrixType: item.deliveryMatrixType,
    deliveryMatrixIndex: index,
    })
  );
}
